define('models/batchSupplySource',["T1", "T1Model"], function (T1, T1Model) {
  T1.Models.BatchSupplySource = T1Model.extend({
    url: "batch_supply_sources/",
    fixture: "-batch_supply_sources"
  });
  return T1.Models.BatchSupplySource;
});
